// extracted by mini-css-extract-plugin
export default {"reactSwitchCheckbox":"Toggle_reactSwitchCheckbox__+NwUk","reactSwitchLabel":"Toggle_reactSwitchLabel__Uj4qi","reactSwitchButton":"Toggle_reactSwitchButton__Sphwz"};